"use client";
import { UserDetailReturnType } from "@/lib/declarations";
import { createContext, useContext, ReactNode } from "react";
export interface User {
  username: string | undefined;
}

interface UserContextType {
  username?: string;
  referralCode?: string;
  phoneNumber?: string;
  email?: string;
  fullName?: string;
  user_information?: UserDetailReturnType["user_information"];
}

interface UserProviderProps {
  children: ReactNode;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export function UserProvider({
  children,
  username,
  fullName,
  email,
  referralCode,
  phoneNumber,
  user_information,
}: {
  children: React.ReactNode;
  username?: string;
  referralCode?: string;
  phoneNumber?: string;
  email?: string;
  fullName?: string;
  user_information?: UserDetailReturnType["user_information"];
}) {
  const value: UserContextType = {
    username,
    referralCode,
    phoneNumber,
    email,
    fullName,
    user_information,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}

export function useUser(): UserContextType {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
}
